import Lottie from 'lottie-react';
import successAnimation from '../../assets/images/gif/Success.json';


const ClubAddedSuccessModal = ({ onClose, onAddAnother, onViewClub }) => {
  return (
    <div className="fixed inset-0 bg-[#000000b5] flex items-center justify-center z-50">
      <div className="bg-white rounded-[20px] p-8 max-w-[550px] w-full mx-4 relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-6 right-6 w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-lg transition-colors"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="#000000"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {/* Success Animation */}
        <div className="flex justify-center mb-6">
          <div className="w-32 h-32">
            <Lottie
              animationData={successAnimation}
              loop={false}
              autoplay={true}
            />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-semibold text-black text-center mb-4 tracking-[0] leading-[normal]">
          Club Added Successfully!!!
        </h2>

        {/* Description */}
        <p className="text-base font-normal text-textcolor text-center mb-8 tracking-[0] leading-[24px]">
          The club has been successfully added to the DRS platform and is now available for management and advertiser visibility.
        </p>

        {/* Action Buttons */}
        <div className="flex gap-4">
          <button
            onClick={onAddAnother}
            className="cursor-pointer flex-1 h-[56px] border-1 border-primary text-primary bg-white rounded-full text-base font-medium tracking-[0] leading-[normal] hover:bg-primary hover:text-white transition-colors"
          >
            Add Another Club
          </button>
          <button
            onClick={onViewClub}
            className="cursor-pointer flex-1 h-[56px] bg-[#0A3A44] text-white rounded-full text-base font-medium tracking-[0] leading-[normal] hover:bg-opacity-90 transition-colors"
          >
            View Club
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClubAddedSuccessModal;
